@use "styles" as *;

.me-modal {
  position: fixed;
  z-index: 10400;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  background-color: $color-background;
  border-radius: $border-radius;
  box-shadow: $box-shadow;
  min-width: min(calc(100% - 2 * 4 * $space), $me-modal-min-width);
  max-width: $me-modal-max-width;
  max-height: calc(100% - 2 * 4 * $space);
  overflow: hidden;

  &--animated {
    transition:
      opacity $transition-timing,
      visibility $transition-timing,
      transform $transition-timing;
  }

  &:not(&--active) {
    opacity: 0;
    visibility: hidden;
    transform: translate(-55%, -50%);
  }

  &__header {
    display: flex;
    align-items: center;
    background-color: $color-background-primary;
    color: $color-white;
  }

  &__title {
    margin-right: auto;
    padding: space(0, 5);
    line-height: $line-height-base;
    font-size: $font-size-l;
    font-weight: $font-weight-semi-bold;

    @include lineClamp(1, $line-height-base, $font-size-l)
  }

  &__close-button.me-button {
    padding: space(3);
    border-width: 0;

    &:focus-visible {
      outline: none;
    }

    .me-button__label {
      color: $color-background;

      &:hover {
        color: $color-gray-200;
      }
    }

    i {
      width: 1em;
      line-height: 1;
      vertical-align: middle;
    }
  }

  &__scroll-container {
    max-height: 100%;
    overflow: auto;
  }

  &__body {
    display: flex;
    align-items: stretch;
    gap: space(5);
    padding: space(5);

    & > .me-separator {
      height: auto;
    }
  }
}
